import * as React from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import { StepForm, ConfiguratorStepTitleAndDescription } from '@grandvisionhq/configurator';
import { spacingHelper } from '@grandvisionhq/iris-ui';
import 'classnames';
import '@swc/helpers';
import '@grandvisionhq/elements';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/state';
import '@grandvisionhq/lib-visuals';
import '@grandvisionhq/utils';
import { ConfigurationSummaryContainer } from '../../components/ConfigurationSummary/ConfigurationSummaryContainer.js';
import { PrescriptionSummaryContainer } from '../../components/PrescriptionSummary/PrescriptionSummaryContainer.js';
import '@grandvisionhq/icons';
import { FrameImage } from '../components/FrameImage/FrameImage.js';
import DesktopStepLayout from '../components/DesktopStepLayout/DesktopStepLayout.js';
import { RxStepWrapper } from '../components/RxStepWrapper/RxStepWrapper.js';

const ReviewStep = ({ onSubmit  })=>{
    const isAboveTabletPortrait = MediaQuery.useIsAbove(MediaQuery.BreakpointName.TABLET_PORTRAIT);
    return /*#__PURE__*/ React.createElement(RxStepWrapper, {
        className: "review-step"
    }, /*#__PURE__*/ React.createElement(DesktopStepLayout, {
        alternativeRightContent: isAboveTabletPortrait ? /*#__PURE__*/ React.createElement(FrameImage, null) : null
    }, /*#__PURE__*/ React.createElement(StepForm, {
        onSubmit: onSubmit
    }, !isAboveTabletPortrait && /*#__PURE__*/ React.createElement(FrameImage, null), /*#__PURE__*/ React.createElement(ConfiguratorStepTitleAndDescription, {
        textAlignment: "left"
    }), /*#__PURE__*/ React.createElement(ConfigurationSummaryContainer, null), /*#__PURE__*/ React.createElement(PrescriptionSummaryContainer, {
        className: spacingHelper([
            'mt-8'
        ])
    }))));
};

export { ReviewStep };
//# sourceMappingURL=ReviewStep.js.map
